import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import delhi from "../../../../assets/indiagate.webp";
import noida from "../../../../assets/noida.webp";
import ghaziabad from "../../../../assets/ghaziabad.webp";
import gurugram from "../../../../assets/gurugram.webp";

import Navbar from "../../../LandingPage/Navbar";
import Footer from "../../../LandingPage/Footer";
import Gateway from "../../../Login/Gateway";

import Porter from "../Porter";
import Areas from "../Areas";
import Transportation from "../Transportation";
import DownloadApp from "../DownloadApp";

import DeliveryCard from "./DeliveryCard/DeliveryCard";
import VehicleFareCard from "./VehicleFareCard/VehicleFareCard";
import TrackingOrderCard from "./TrackingOrderCard/TrackingOrderCard";
import CaptainSearchingCard from "./CaptainSearchingCard/CaptainSearchingCard";
import AddCustomerDetails from "./AddCustomerDetails";
import PageState from "../../../../Routes/PageState";

const VALID_BOOKING_CARDS = [
  "gateway",
  "customer",
  "booking",
  "fare",
  "captain",
  "tracking",
];

const Bookings = () => {
  const location = useLocation();

  const rawSelectedCity =
    location.state?.city || sessionStorage.getItem("selectedCity") || "Delhi";

  const normalizeCityName = (city = "") => {
    const value = String(city).trim().toLowerCase();

    if (value.includes("delhi")) return "Delhi";

    if (value.includes("noida")) return "Noida";

    if (value.includes("gurugram") || value.includes("gurgaon")) {
      return "Gurugram";
    }

    if (value.includes("gaziabad") || value.includes("ghaziabad")) {
      return "Ghaziabad";
    }

    return "Delhi";
  };

  const selectedCity = normalizeCityName(rawSelectedCity);

  const initialVehicle = location.state?.vehicle || "Two Wheeler";

  const [selectedVehicle, setSelectedVehicle] = useState(initialVehicle);
  const [acceptedRide, setAcceptedRide] = useState(null);
  const [selectedFare, setSelectedFare] = useState(0);

  const [activeCard, setActiveCard] = useState(null);

  const [flowState, setFlowState] = useState(null);

  const [deliveryForm, setDeliveryForm] = useState({
    customerId: "",
    userId: "",

    firstName: "",
    lastName: "",
    privacyPolicy: false,

    pickupAddress: "",
    pickupLatitude: "",
    pickupLongitude: "",

    dropAddress: "",
    dropLatitude: "",
    dropLongitude: "",

    senderName: "",
    senderMobile: "",
    receiverName: "",
    receiverMobile: "",

    deliveryType: "instant",
    scheduleDate: "",
    scheduleTime: "",

    parcelId: "",
  });

  const [selectedVehicleMeta, setSelectedVehicleMeta] = useState({
    weight: "",
    dimension: "",
  });

  const cityBanners = {
    Delhi: delhi,
    Noida: noida,
    Ghaziabad: ghaziabad,
    Gaziabad: ghaziabad,
    Gurugram: gurugram,
    Gurgaon: gurugram,
  };

  const banner = cityBanners[selectedCity] || delhi;

  const cleanMobile = (value) => {
    return String(value || "").replace(/\D/g, "");
  };

  const getSessionUser = () => {
    try {
      const storedUser = sessionStorage.getItem("user");

      if (!storedUser) {
        return null;
      }

      return JSON.parse(storedUser);
    } catch (error) {
      console.error("Invalid session user:", error);
      return null;
    }
  };

  const getMobileFromUser = (userData, mobileFromGateway = "") => {
    const storedLoginMobile = sessionStorage.getItem("login_mobile");

    return cleanMobile(
      mobileFromGateway ||
        storedLoginMobile ||
        userData?.mobile ||
        userData?.phone ||
        userData?.customerMobile ||
        userData?.mobileNumber ||
        userData?.username ||
        "",
    );
  };

  const loadSavedCustomerDetails = (mobile) => {
    if (!mobile) {
      return null;
    }

    try {
      const savedCustomerDetails = localStorage.getItem(
        `booking_customer_${mobile}`,
      );

      if (!savedCustomerDetails) {
        return null;
      }

      return JSON.parse(savedCustomerDetails);
    } catch (error) {
      console.error("Invalid saved customer details:", error);
      return null;
    }
  };

  const hasCompletedCustomerProfile = (userData, savedDetails = null) => {
    const firstName =
      userData?.firstName ||
      userData?.first_name ||
      userData?.firstname ||
      savedDetails?.firstName ||
      savedDetails?.first_name ||
      savedDetails?.firstname ||
      "";

    const lastName =
      userData?.lastName ||
      userData?.last_name ||
      userData?.lastname ||
      savedDetails?.lastName ||
      savedDetails?.last_name ||
      savedDetails?.lastname ||
      "";

    const privacyPolicy =
      userData?.privacyPolicy ||
      userData?.privacy_policy ||
      userData?.privacy_policy_accepted ||
      savedDetails?.privacyPolicy ||
      savedDetails?.privacy_policy ||
      savedDetails?.privacy_policy_accepted ||
      "";

    const isPrivacyAccepted =
      privacyPolicy === "Y" ||
      privacyPolicy === "y" ||
      privacyPolicy === true ||
      privacyPolicy === "true";

    return Boolean(
      String(firstName).trim() && String(lastName).trim() && isPrivacyAccepted,
    );
  };

  const showFlowState = ({
    type = "error",
    title,
    description,
    actionText = "Try Again",
    onAction,
  }) => {
    setFlowState({
      type,
      title,
      description,
      actionText,
      onAction,
    });
  };

  const closeFlowState = () => {
    setFlowState(null);
  };

  const resetBookingFlow = () => {
    setAcceptedRide(null);
    setSelectedFare(0);

    setSelectedVehicleMeta({
      weight: "",
      dimension: "",
    });

    setDeliveryForm((prev) => ({
      ...prev,

      pickupAddress: "",
      pickupLatitude: "",
      pickupLongitude: "",

      dropAddress: "",
      dropLatitude: "",
      dropLongitude: "",

      receiverName: "",
      receiverMobile: "",

      deliveryType: "instant",
      scheduleDate: "",
      scheduleTime: "",

      parcelId: "",
    }));

    setFlowState(null);
    setActiveCard("booking");
  };

  const openBookingWithMobile = (mobile, savedDetails = null) => {
    const fullName = `${savedDetails?.firstName || ""} ${
      savedDetails?.lastName || ""
    }`.trim();

    setDeliveryForm((prev) => ({
      ...prev,
      ...(savedDetails || {}),

      customerId:
        prev.customerId ||
        savedDetails?.customerId ||
        savedDetails?.userId ||
        mobile ||
        "",

      userId:
        prev.userId ||
        savedDetails?.userId ||
        savedDetails?.customerId ||
        mobile ||
        "",

      senderName: prev.senderName || savedDetails?.senderName || fullName || "",

      senderMobile:
        savedDetails?.senderMobile || mobile || prev.senderMobile || "",
    }));

    setFlowState(null);
    setActiveCard("booking");
  };

  const openCustomerWithMobile = (mobile) => {
    setDeliveryForm((prev) => ({
      ...prev,

      customerId: prev.customerId || mobile || "",
      userId: prev.userId || mobile || "",
      senderMobile: mobile || prev.senderMobile || "",
    }));

    setFlowState(null);
    setActiveCard("customer");
  };

  useEffect(() => {
    const sessionUser = getSessionUser();

    if (!sessionUser) {
      setActiveCard("gateway");
      return;
    }

    const mobile = getMobileFromUser(sessionUser);
    const savedDetails = loadSavedCustomerDetails(mobile);

    if (hasCompletedCustomerProfile(sessionUser, savedDetails)) {
      const firstName =
        sessionUser?.firstName ||
        sessionUser?.first_name ||
        savedDetails?.firstName ||
        savedDetails?.first_name ||
        "";

      const lastName =
        sessionUser?.lastName ||
        sessionUser?.last_name ||
        savedDetails?.lastName ||
        savedDetails?.last_name ||
        "";

      openBookingWithMobile(mobile, {
        firstName,
        lastName,

        privacyPolicy:
          sessionUser?.privacyPolicy === "Y" ||
          sessionUser?.privacy_policy === "Y" ||
          savedDetails?.privacyPolicy === true ||
          savedDetails?.privacyPolicy === "Y" ||
          savedDetails?.privacy_policy === "Y",

        senderMobile: mobile,
      });

      return;
    }

    openCustomerWithMobile(mobile);
  }, []);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [activeCard, flowState]);

  const handleGatewayNext = (mobileFromGateway, userDataFromGateway = null) => {
    const sessionUser = getSessionUser();

    const finalUserData = userDataFromGateway || sessionUser || {};

    const mobile = getMobileFromUser(finalUserData, mobileFromGateway);

    if (!mobile) {
      showFlowState({
        type: "error",
        title: "Mobile Number Not Found",
        description:
          "We could not identify your mobile number. Please log in again.",
        actionText: "Go to Login",
        onAction: () => {
          closeFlowState();
          setActiveCard("gateway");
        },
      });

      return;
    }

    sessionStorage.setItem("login_mobile", mobile);

    const savedDetails = loadSavedCustomerDetails(mobile);

    const isOldCustomer = hasCompletedCustomerProfile(
      finalUserData,
      savedDetails,
    );

    if (isOldCustomer) {
      const firstName =
        finalUserData?.firstName ||
        finalUserData?.first_name ||
        savedDetails?.firstName ||
        savedDetails?.first_name ||
        "";

      const lastName =
        finalUserData?.lastName ||
        finalUserData?.last_name ||
        savedDetails?.lastName ||
        savedDetails?.last_name ||
        "";

      openBookingWithMobile(mobile, {
        firstName,
        lastName,

        privacyPolicy:
          finalUserData?.privacyPolicy === "Y" ||
          finalUserData?.privacy_policy === "Y" ||
          savedDetails?.privacyPolicy === true ||
          savedDetails?.privacyPolicy === "Y" ||
          savedDetails?.privacy_policy === "Y",

        senderMobile: mobile,
      });

      return;
    }

    openCustomerWithMobile(mobile);
  };

  const handleCustomerNext = () => {
    const sessionUser = getSessionUser();

    const mobile = cleanMobile(
      deliveryForm?.senderMobile || getMobileFromUser(sessionUser),
    );

    if (!mobile) {
      showFlowState({
        type: "error",
        title: "Mobile Number Required",
        description: "Please enter a valid mobile number before continuing.",
        actionText: "Back to Customer Details",
        onAction: () => {
          closeFlowState();
          setActiveCard("customer");
        },
      });

      return;
    }

    sessionStorage.setItem("login_mobile", mobile);
    sessionStorage.setItem("customerId", mobile);
    sessionStorage.setItem("userId", mobile);

    localStorage.setItem(
      `booking_customer_${mobile}`,
      JSON.stringify({
        customerId: mobile,
        userId: mobile,
        firstName: deliveryForm.firstName || "",
        lastName: deliveryForm.lastName || "",
        privacyPolicy: deliveryForm.privacyPolicy || false,
        senderMobile: mobile,
      }),
    );

    setDeliveryForm((prev) => ({
      ...prev,
      customerId: prev.customerId || mobile,
      userId: prev.userId || mobile,
      senderMobile: prev.senderMobile || mobile,
    }));

    setFlowState(null);
    setActiveCard("booking");
  };

  const handleFareNext = (data) => {
    const parcelId = data?.parcelId;

    if (!parcelId) {
      showFlowState({
        type: "noData",
        title: "Parcel ID Not Found",
        description:
          "Your booking was not created correctly because the parcel ID is missing.",
        actionText: "Back to Fare",
        onAction: () => {
          closeFlowState();
          setActiveCard("fare");
        },
      });

      return;
    }

    setDeliveryForm((prev) => ({
      ...prev,
      parcelId,
    }));

    setFlowState(null);
    setActiveCard("captain");
  };

  const handleCaptainNext = (rideData) => {
    if (!rideData) {
      showFlowState({
        type: "noData",
        title: "Captain Data Not Found",
        description:
          "No captain details were received. Please search for a captain again.",
        actionText: "Search Again",
        onAction: () => {
          closeFlowState();
          setActiveCard("captain");
        },
      });

      return;
    }

    setAcceptedRide(rideData);
    setFlowState(null);
    setActiveCard("tracking");
  };

  const handleTrackingCancel = () => {
    setAcceptedRide(null);

    setDeliveryForm((prev) => ({
      ...prev,
      parcelId: "",
    }));

    setFlowState(null);
    setActiveCard("booking");
  };

  const isInvalidActiveCard =
    activeCard !== null && !VALID_BOOKING_CARDS.includes(activeCard);

  const renderBookingContent = () => {
    if (activeCard === null) {
      return <PageState type="loading" compact />;
    }

    if (flowState) {
      return (
        <PageState
          type={flowState.type}
          title={flowState.title}
          description={flowState.description}
          showActionButton
          actionText={flowState.actionText}
          onAction={flowState.onAction}
          showHomeButton
          compact
        />
      );
    }

    if (isInvalidActiveCard) {
      return (
        <PageState
          type="error"
          title="Invalid Booking Step"
          description="The current booking step is invalid. Please restart your booking."
          showActionButton
          actionText="Restart Booking"
          onAction={resetBookingFlow}
          showHomeButton
          compact
        />
      );
    }

    if (activeCard === "gateway") {
      return (
        <Gateway
          isBookingFlow={true}
          selectedCity={selectedCity}
          onNext={handleGatewayNext}
        />
      );
    }

    if (activeCard === "customer") {
      return (
        <AddCustomerDetails
          formData={deliveryForm}
          setFormData={setDeliveryForm}
          selectedCity={selectedCity}
          onNext={handleCustomerNext}
        />
      );
    }

    if (activeCard === "booking") {
      return (
        <DeliveryCard
          formData={deliveryForm}
          setFormData={setDeliveryForm}
          selectedVehicle={selectedVehicle}
          onNext={() => {
            setFlowState(null);
            setActiveCard("fare");
          }}
        />
      );
    }

    if (activeCard === "fare") {
      return (
        <VehicleFareCard
          formData={deliveryForm}
          setFormData={setDeliveryForm}
          selectedVehicle={selectedVehicle}
          setSelectedVehicle={setSelectedVehicle}
          setSelectedFare={setSelectedFare}
          setSelectedVehicleMeta={setSelectedVehicleMeta}
          onBack={() => {
            setFlowState(null);
            setActiveCard("booking");
          }}
          onNext={handleFareNext}
        />
      );
    }

    if (activeCard === "captain") {
      return (
        <CaptainSearchingCard
          formData={deliveryForm}
          selectedVehicle={selectedVehicle}
          baseFare={selectedFare}
          vehicleMeta={selectedVehicleMeta}
          onBack={() => {
            setFlowState(null);
            setActiveCard("fare");
          }}
          onNext={handleCaptainNext}
        />
      );
    }

    if (activeCard === "tracking") {
      if (!deliveryForm?.parcelId) {
        return (
          <PageState
            type="noData"
            title="Tracking Data Not Found"
            description="The parcel ID required to track this booking is unavailable."
            showActionButton
            actionText="Create New Booking"
            onAction={resetBookingFlow}
            showHomeButton
            compact
          />
        );
      }

      return (
        <TrackingOrderCard
          formData={deliveryForm}
          parcelId={deliveryForm.parcelId}
          selectedVehicle={selectedVehicle}
          acceptedRide={acceptedRide}
          vehicleMeta={selectedVehicleMeta}
          onBack={() => {
            setFlowState(null);
            setActiveCard("captain");
          }}
          onCancel={handleTrackingCancel}
          onNext={() => {}}
        />
      );
    }

    return null;
  };

  return (
    <>
      <Navbar />

      <div className="relative flex min-h-[580px] flex-col items-center justify-start overflow-hidden px-3 pb-6 pt-[80px] sm:pt-[85px] md:min-h-[720px] md:pt-[90px] lg:min-h-[760px] lg:pt-[95px] xl:pt-[100px]">
        <div className="image-section absolute left-0 top-0 -z-10 h-full w-full">
          <img
            src={banner}
            alt={`${selectedCity} delivery background`}
            className="h-full w-full object-cover object-top"
          />

          <div className="image-overlay absolute inset-0 bg-black/30" />
        </div>

        {renderBookingContent()}
      </div>

      <Porter />
      <Areas />
      <DownloadApp />
      <Transportation />
      <Footer />
    </>
  );
};

export default Bookings;
